import { User } from "../../../entity/User";
import { Method, ROUTES } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import { UserDTO } from "../../dto/User.dto";
import { mapToUsers } from "../../mapper/UserMapper";

export class WSUsers {
  private static instance: WSUsers;

  private constructor() {}

  public static getInstance(): WSUsers {
    if (!WSUsers.instance) {
      WSUsers.instance = new WSUsers();
    }
    return WSUsers.instance;
  }

  public async getUsersByStore(storeId: string): Promise<User[]> {
    try {
      const url = `${ROUTES.USERS}${ROUTES.GET_USERS_BY_STORE}${storeId}`;
      const response = await fetchAPI<UserDTO[]>({
        url,
        method: Method.GET,
        isAuthenticated: true,
      });

      return mapToUsers(response.data);
    } catch (error) {
      console.error("Error getting users by store:", error);
      throw error;
    }
  }

  public async createNewMember(user: User): Promise<User> {
    try {
      const url = `${ROUTES.USERS}${ROUTES.CREATE_NEW_MEMBER}`;
      const response = await fetchAPI<UserDTO>({
        url,
        method: Method.POST,
        isAuthenticated: true,
        params: user,
      });

      return mapToUsers([response.data])[0];
    } catch (error) {
      console.error("Error creating new member:", error);
      throw error;
    }
  }

  public async updateMember(user: User): Promise<void> {
    try {
      const url = `${ROUTES.USERS}${ROUTES.UPDATE_MEMBER}`;
      await fetchAPI<UserDTO>({
        url,
        method: Method.PUT,
        isAuthenticated: true,
        params: user,
      });
    } catch (error) {
      console.error("Error updating member:", error);
      throw error;
    }
  }

  public async countUsers(): Promise<number> {
    try {
      const url = `${ROUTES.USERS}${ROUTES.COUNT_USERS}`;
      const response = await fetchAPI<number>({
        url,
        method: Method.GET,
        isAuthenticated: true,
      });

      return response.data;
    } catch (error) {
      console.error("Error counting users:", error);
      throw error;
    }
  }

  public async getUserById(userId: string): Promise<User> {
    try {
      const url = `${ROUTES.USERS}${ROUTES.GET_USER_BY_ID}${userId}`;
      const response = await fetchAPI<UserDTO>({
        url,
        method: Method.GET,
        isAuthenticated: true,
      });

      return mapToUsers([response.data])[0];
    } catch (error) {
      console.error("Error getting user by id:", error);
      throw error;
    }
  }
}

export const WSUsersInstance = WSUsers.getInstance();
